import { z } from 'zod'

/** A real calendar date, YYYY-MM-DD (e.g. a due day or a day off, in the user's time zone). */
export const calendarDate = z.iso.date()
